import { render, staticRenderFns } from "./AssistantInformation.vue?vue&type=template&id=228ff352&scoped=true"
import script from "./AssistantInformation.vue?vue&type=script&lang=js"
export * from "./AssistantInformation.vue?vue&type=script&lang=js"
import style0 from "./AssistantInformation.vue?vue&type=style&index=0&id=228ff352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ff352",
  null
  
)

export default component.exports